class Storage {
  async checkToken() {
    let pass = false;
    pass = localStorage.getItem("token") == null ? false : true;
    return pass;
  }

  setToken(token: string) {
    localStorage.setItem("token", token);
  }
  getToken() {
    return localStorage.getItem("token");
  }

  clearToken() {
    localStorage.removeItem("token");
    localStorage.removeItem("username");
    localStorage.removeItem("lang");
    localStorage.removeItem("noti");
    localStorage.clear();
    sessionStorage.clear();
  }

  setUsername(username: string) {
    localStorage.setItem("username", username);
  }
  getUsername() {
    return localStorage.getItem("username");
  }

  setLang(lang: any | undefined) {
    localStorage.setItem("lang", lang);
  }
  getLang() {
    return localStorage.getItem("lang");
  }
}
export default new Storage();
